import { CommonToolNames } from './commonToolContract';
import { DocumentSearchToolName } from './documentSearchContract';
import { ShopProductToolNames } from './shopAssistant/shopProductToolsContract';

export * from './shopAssistant/shopProductToolsContract';
export * from './documentSearchContract';
export * from './commonToolContract';

export const ToolNames = {
  ...ShopProductToolNames,
  ...CommonToolNames,
  DocumentSearch: DocumentSearchToolName,
} as const;

export type ToolName = (typeof ToolNames)[keyof typeof ToolNames];
